/**
 * Returns the origin of the parent window for use as a postMessage target.
 * Falls back to '*' when the parent is cross-origin and its origin
 * cannot be read directly.
 *
 * This is intentionally in its own module so that lightweight entry
 * points (e.g. ReactCommon) can use it without pulling in the heavier
 * AdminHelper dependency tree (react-router-dom, etc.).
 *
 * @returns {string} The parent origin or '*'
 */
export function getTargetOrigin() {
	try {
		return window.parent.location.origin;
	} catch (e) {
		return '*';
	}
}
